function makeAppConfig() {
    const AppConfig = {
        theme: 'theme-brown'
    };
    return AppConfig;
  }

export const APPCONFIG = makeAppConfig();



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/config.ts